module.exports = __webpack_public_path__ + "img/AdobeStock_186417756.dd50011f.jpeg";